var React = require('react');

function Neutral (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5,15A7.5,7.5,0,0,1,2.2,2.2,7.5,7.5,0,0,1,12.8,12.8,7.451,7.451,0,0,1,7.5,15Zm0-13.828A6.328,6.328,0,1,0,13.828,7.5,6.335,6.335,0,0,0,7.5,1.172Zm2.93,8.584a.586.586,0,0,0-.586-.586H5.156a.586.586,0,0,0,0,1.172H9.844A.586.586,0,0,0,10.43,9.756ZM4.922,4.863a.732.732,0,1,1-.732.732A.732.732,0,0,1,4.922,4.863ZM9.316,5.6a.732.732,0,1,0,.732-.732A.732.732,0,0,0,9.316,5.6Z","transform":"translate(0 0)","fill":"#dedede"}));
}

Neutral.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Neutral;

Neutral.default = Neutral;
